import { render, staticRenderFns } from "./modalConfirmBan.vue?vue&type=template&id=d956a94e&"
import script from "./modalConfirmBan.vue?vue&type=script&lang=js&"
export * from "./modalConfirmBan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports